import { Capacitor } from "@capacitor/core";

/** True when running inside the Capacitor native shell (iOS or Android). */
export const isNative = (): boolean => Capacitor.isNativePlatform();

/** "ios" | "android" | "web" */
export const getPlatform = (): "ios" | "android" | "web" =>
  Capacitor.getPlatform() as "ios" | "android" | "web";

/** Custom-scheme OAuth callback for native shells. */
export const NATIVE_OAUTH_REDIRECT = "com.workitect.app://auth/callback";

/** Chooses the correct OAuth redirect for the current runtime. */
export const getOAuthRedirect = (): string => {
  if (isNative()) return NATIVE_OAUTH_REDIRECT;
  return `${window.location.origin}/auth/callback`;
};
